(function($){
    var banner = $('#banner');
    
    if( banner ) {

        $('.banner__close-icon').on('click', function() {
            banner.animate({height: "0px", padding: 0}, 100);
        })
    }
})(jQuery);
